
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OnHoldReason } from 'enums/OnHoldReason';
import { LedgerPostModel } from './Entities.Accounting.LedgerPost';
import { Model, ModelProperty } from 'models/Model';


export class LedgerHeaderModel extends Model<LedgerHeaderModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'onHoldReason', type: 'OnHoldReason' },
		{ name: 'registedInExternalAccountingSystem', type: 'boolean' },
		{ name: 'compactId', type: 'string' },
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'draftDocumentNo', type: 'string' },
		{ name: 'postedDocumentNo', type: 'string' },
		{ name: 'postedDate', type: 'Date' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'closed', type: 'boolean' },
		{ name: 'originalDueDate', type: 'Date' },
		{ name: 'issuedReminderLevel', type: 'number' },
		{ name: 'brandId', type: 'string' },
		{ name: 'overrideExternalDueDate', type: 'boolean' },
		{ name: 'ledgerPosts', type: 'LedgerPostModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new LedgerPostModel }, properties: () => { return LedgerPostModel.classProperties } }
	];
	[key: string]: any;
	
	public onHoldReason?: OnHoldReason;
	public registedInExternalAccountingSystem: boolean;
	public compactId: string;
	public id?: string;
	public draftDocumentNo: string;
	public postedDocumentNo: string;
	public postedDate?: Date;
	public dueDate?: Date;
	public closed: boolean;
	public originalDueDate?: Date;
	public issuedReminderLevel?: number;
	public brandId?: string;
	public overrideExternalDueDate: boolean;
	public ledgerPosts: LedgerPostModel[];
    
	constructor(){
		super();
		this.onHoldReason = undefined;
		this.registedInExternalAccountingSystem = false;
		this.compactId = '';
		this.id = undefined;
		this.draftDocumentNo = '';
		this.postedDocumentNo = '';
		this.postedDate = undefined;
		this.dueDate = undefined;
		this.closed = false;
		this.originalDueDate = undefined;
		this.issuedReminderLevel = undefined;
		this.brandId = undefined;
		this.overrideExternalDueDate = false;
		this.ledgerPosts = [];
		
	}
	getProperties(){
		return LedgerHeaderModel.classProperties;
	}
}

